import React , {Component } from 'react';
import AUX from '../../hoc/Aux_';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import { Alert, AlertTitle } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import { useSpring, animated } from 'react-spring/web.cjs'; // web.cjs is required for IE 11 support
import Config from "../../config/";
const ROOT_URL = Config.rooturl;
function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  return (
    <SvgIcon className="close" fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}

function TransitionComponent(props) {
  const style = useSpring({
    from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
    to: { opacity: props.in ? 1 : 0, transform: `translate3d(${props.in ? 0 : 20}px,0,0)` },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

TransitionComponent.propTypes = {
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
};

const StyledTreeItem = withStyles((theme) => ({
  iconContainer: {
    '& .close': {
      opacity: 0.3,
    },
  },
  group: {
    marginLeft: 7,
    paddingLeft: 18,
    borderLeft: `1px dashed ${fade(theme.palette.text.primary, 0.4)}`,
  },
}))((props) => <TreeItem {...props} TransitionComponent={TransitionComponent} />);

const useStyles = makeStyles({
  root: {
    height: 264,
    flexGrow: 1,
    maxWidth: 400,
  },
});


class UnduhBukuKugi extends Component{

    constructor(props) {
      super(props);
      this.state = {

        code:"",

      };
    }

    render(){
        return(
          <AUX>
            <section className="sections" style = {{paddingTop:"5%"}}>
              <div className="container">
                <div className="row justify-content-center" >
                <Grid item xs={3}>
                  <Paper >
                    <Alert severity="warning">
                      Modul Webpage KUGI
                    </Alert>
                    <div  >
                      <center>
                      <img src = {"https://kugi.ina-sdi.or.id/images/Garuda_thumb.png"} />
                       <br/><b>Katalog Unsur Geografi Indonesia</b>
                      <Divider />
                      <div style = {{padding: "10px"}}><b>Browse: <a href = "https://kugi.ina-sdi.or.id/kugi" target = "_blank">Data KUGI</a></b></div>
                      <Divider />
                      <br/>
                      <a target = "_blank" href = "https://kugi.ina-sdi.or.id/buku/Panduan/Tutorial Penggunaan Web KUGI.pdf"><center><img src = {"https://kugi.ina-sdi.or.id/images/pdf.png"} /></center>
                      </a>Download Tutorial Web KUGI

                      </center>
                    </div>
                  </Paper>
                </Grid>
                  <Grid item xs={9} style = {{paddingLeft:"10px"}}>
                  <Paper >
                  <Alert severity="info">
                    Unduh Template KUGI
                  </Alert>
                  <TreeView
                    defaultExpanded={['15','16']}
                    defaultCollapseIcon={<MinusSquare />}
                    defaultExpandIcon={<PlusSquare />}
                    defaultEndIcon={<CloseSquare />}
                  >
                    <StyledTreeItem nodeId="4" label="Versi 2.0">
                      <StyledTreeItem nodeId="5" label="ARCGIS" onClick={()=>{window.open("/data/V2/kugi_v.2.zip");}}/>

                      <StyledTreeItem nodeId="6" label="PostGIS" onClick={()=>{window.open("/data/V2/KUGI_V2.sql");}}/>
                    </StyledTreeItem>

                    <StyledTreeItem nodeId="7" label="Versi 3.0">
                      <StyledTreeItem nodeId="8" label="ARCGIS" onClick={()=>{window.open("/data/V3/KUG_V.3.zip");}}/>
                      <StyledTreeItem nodeId="228" label="PostGIS" onClick={()=>{window.open("/data/V3/KUGI_V3.sql");}}/>

                    </StyledTreeItem>
                    <StyledTreeItem nodeId="12" label="Versi 4.0">
                      <StyledTreeItem nodeId="13" label="ARCGIS" onClick={()=>{window.open("/data/V4/KUGI_v.4(Skala).zip");}}/>
                      <StyledTreeItem nodeId="13" label="PostGIS" onClick={()=>{window.open("/data/V4/KUGI_V.4.sql");}}/>


                    </StyledTreeItem>
                    <StyledTreeItem nodeId="15" label="Versi 5.0">

                        <StyledTreeItem nodeId="1118" label="Skala 1:5.000 (ArcGIS)" onClick={()=>{window.open("/data/KUGI5_5K.zip");}}/>
                        <StyledTreeItem nodeId="1119" label="Skala 1:10.000 (ArcGIS)" onClick={()=>{window.open("/data/KUGI5_10K.zip");}}/>
                        <StyledTreeItem nodeId="1120" label="Skala 1:25.000 (ArcGIS)" onClick={()=>{window.open("/data/KUGI5_25K.zip");}}/>
                        <StyledTreeItem nodeId="1121" label="Skala 1:50.000 (ArcGIS)" onClick={()=>{window.open("/data/KUGI5_50K.zip");}}/>
                        <StyledTreeItem nodeId="1123" label="Skala 1:250.000 (ArcGIS)" onClick={()=>{window.open("/data/KUGI5_250K.zip");}}/>
                        <StyledTreeItem nodeId="1124" label="Skala 1:5.000 (QGIS)" onClick={()=>{window.open("/data/TEMPLATE_5K.zip");}}/>
                        <StyledTreeItem nodeId="1125" label="Skala 1:10.000 (QGIS)" onClick={()=>{window.open("/data/TEMPLATE_10K.zip");}}/>
                        <StyledTreeItem nodeId="1126" label="Skala 1:25.000 (QGIS)" onClick={()=>{window.open("/data/TEMPLATE_25K.zip");}}/>
                        <StyledTreeItem nodeId="1127" label="Skala 1:50.000 (QGIS)" onClick={()=>{window.open("/data/TEMPLATE_50K.zip");}}/>
                        <StyledTreeItem nodeId="1129" label="Skala 1:250.000 (QGIS)" onClick={()=>{window.open("/data/TEMPLATE_250K.zip");}}/>
                      </StyledTreeItem> 

                    <StyledTreeItem nodeId="16" label="Versi 5.1">

                        <StyledTreeItem nodeId="1118" label="Versi Terbaru akan segera hadir" />
                      </StyledTreeItem> 
                  </TreeView>
                  </Paper>
                  </Grid>
                </div>
              </div>
            </section>
          </AUX>
        );
    }
}

export default UnduhBukuKugi;
